var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"content"},[(_vm.message.self)?_c('ParsedMessage',{attrs:{"network":_vm.network,"message":_vm.message}}):[_c('Username',{attrs:{"user":_vm.message.from}}),_vm._v("\n\t\tis back\n\t")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }